import { render, staticRenderFns } from "./ContactCards.vue?vue&type=template&id=ce7242f4&scoped=true"
import script from "./ContactCards.vue?vue&type=script&lang=js"
export * from "./ContactCards.vue?vue&type=script&lang=js"
import style0 from "./ContactCards.vue?vue&type=style&index=0&id=ce7242f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7242f4",
  null
  
)

export default component.exports